import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Box,
  AppBar,
  Tabs,
  Tab,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Snackbar, Divider,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SchoolIcon from '@mui/icons-material/School';
import PaidIcon from '@mui/icons-material/Paid';
import PublicIcon from '@mui/icons-material/Public';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // CheckCircle icon for better visual representation
import EventIcon from '@mui/icons-material/EventAvailable';
import ActivitiesIcon from '@mui/icons-material/Star';
// import ausdegree from '../img/ausdegree.jpeg';
import ausdegree from '../img/ausdegree.jpg'
import Webhead from '../Webhead';
import { useState } from 'react';
import Webfoot from '../Webfoot';


const Saustralia = () => {

  const [value, setValue] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const benefits = [
    {
      title: "A renowned destination for students from India",
      description: "A top choice for Indian students seeking global education.",
      icon: <PaidIcon />
    },
    {
      title: "Globally accredited qualifications",
      description: "Earn globally recognized and accredited qualifications.",
      icon: <SchoolIcon />
    },
    {
      title: "Rights for overseas students",
      description: "Protective rights and support for international students.",
      icon: <PublicIcon />
    },
    {
      title: "Linguistic diversity",
      description: "Experience a rich cultural and linguistic diversity.",
      icon: <EmojiPeopleIcon />
    },
    {
      title: "Monetary aid from the Government",
      description: "Government-provided financial aid for students.",
      icon: <LiveHelpIcon />
    },
    {
      title: "Steadily growing economy offering good job.",
      description: "Thriving economy with promising job opportunities.",
      icon: <SchoolIcon />
    },
    {
      title: "A degree that is valued across the world",
      description: "Attain a degree respected and valued globally.",
      icon: <SchoolIcon />
    },
    {
      title: "Amazing Climate & Outdoor Lifestyle",
      description: "Attain a degree respected and valued globally.",
      icon: <SchoolIcon />
    },
  ];

  return (
    <div>
      <Webhead />
      <div>
        {/* <StudyInAustralia /> */}
        <Container maxWidth="lg" style={{ marginTop: '20px', marginBottom: '40px' }}>

          <Box
            sx={{
              backgroundImage: `url(${ausdegree})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              color: 'white',
              padding: '100px 20px',
              textAlign: 'center',
            }}
          >
            <Typography variant="h4" gutterBottom>
              Pursue Your Dream In Australia
            </Typography>
            <Typography variant="h6" paragraph>
              Accelerate Your Career With An Australian Education
            </Typography>
            <Button variant="contained" color="primary" onClick={() => setSnackbarOpen(true)}>
              Get Started
            </Button>
          </Box>

          {/* Tabs for Different Sections */}
          <AppBar position="static" color="default">
            <Tabs value={value} onChange={handleTabChange} aria-label="tabs">
              <Tab label="Why Study in Australia?" />
              <Tab label="In Australia" />
              {/* <Tab label="Student Life" /> */}
            </Tabs>
          </AppBar>

          {value === 0 && (
  <Box sx={{ padding: '5px 0' }}>
    <br />
    <Box sx={{ padding: '20px', backgroundColor: '#F9BB16', borderRadius: '8px', textAlign: 'center' }}>
  <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'black'}}>
    Study In Australia
  </Typography>
</Box>
<br />
<Typography variant="h6" sx={{ fontWeight: 'bold', color: 'black'}}>
Accelerate Your Career With An Australian Education
  </Typography>
                            <Typography variant="body1" paragraph>
                            Australia is one of the best destinations for students looking to pursue an education abroad. Not only does it boast of 8 universities in the top 100 universities in the world, it also offers an amazing learning environment. Looking to study in Australia? Trent can help you create an Australian Student Visa application package that has the highest chances of success. Our expertise in Australian immigration processes means that we are best positioned to help you navigate its tricky procedures. Trent helps students identify the right course and college in Australia that can set them on the path to a successful career.
                            </Typography>
                            <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'black'}}>
Why study in Australia
  </Typography>
  <br />
    <Grid container spacing={2} justifyContent="center">

 
      {benefits.map((benefit, index) => (
        <Grid item xs={6} sm={6} md={6} key={index}>
          
          <Card variant="outlined" sx={{ display: 'flex', alignItems: 'center', padding: '16px', boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}>
            <IconButton color="primary" sx={{ marginRight: '16px' }}>
              {benefit.icon}
            </IconButton>
            <CardContent sx={{ flex: 1 }}>
              <Typography variant="h6" gutterBottom>
                {benefit.title}
              </Typography>
              {/* Uncomment below line if you want to include the description */}
              {/* <Typography variant="body2">{benefit.description}</Typography> */}
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  </Box>
)}

          {value === 1 && (
            <Box sx={{ padding: '20px', borderRadius: '8px', backgroundColor: '#fafafa' }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                Admission Process
              </Typography>
              <Typography variant="body1" paragraph>
                The admission process for studying in Australia typically includes the following steps:
              </Typography>
              <ul style={{ listStyleType: 'none', padding: 0 }}>
                {[
                  "Choose a program and institution.",
                  "Check the admission requirements.",
                  "Prepare required documents (transcripts, letters of recommendation, etc.).",
                  "Submit your application online.",
                  "Receive an acceptance letter and pay tuition fees.",
                  "Apply for a study permit.",
                ].map((step, index) => (
                  <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#fff' }}>
                    <SchoolIcon color="primary" style={{ marginRight: '10px' }} />
                    <Typography variant="body1">{step}</Typography>
                  </li>
                ))}
              </ul>
            </Box>
          )}

          {value === 2 && (
            <Box sx={{ padding: '20px', borderRadius: '8px', backgroundColor: '#fafafa', marginTop: 4 }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
                Student Life
              </Typography>
              <Typography variant="body1" paragraph>
                Student life in Australia is diverse and vibrant. You can expect to engage in:
              </Typography>
              <ul style={{ listStyleType: 'none', padding: 0 }}>
                {[
                  "Participating in clubs and organizations.",
                  "Attending social events and networking opportunities.",
                  "Enjoying the cultural and recreational activities in your area.",
                ].map((activity, index) => (
                  <li key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#fff' }}>
                    <EventIcon color="primary" style={{ marginRight: '10px' }} />
                    <Typography variant="body1">{activity}</Typography>
                  </li>
                ))}
              </ul>
            </Box>
          )}

<Box sx={{ padding: '20px' }}>
      <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
        Why Should You Settle In Australia?
      </Typography>
      <Divider sx={{ marginBottom: 2 }} />
      <Typography variant="body1" paragraph>
        – Earn in dollars
      </Typography>
      <Typography variant="body1" paragraph>
        – Free education for children
      </Typography>
      <Typography variant="body1" paragraph>
        – Healthcare and retirement benefits
      </Typography>

      <Divider sx={{ margin: '20px 0' }} />

      <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
        Begin A New Life In Australia
      </Typography>
      <Divider sx={{ marginBottom: 2 }} />
      <Typography variant="body1" paragraph>
        With sunny beaches, vibrant cities and a welcoming culture, Australia is one of the world’s most desired migration destinations. Qualified professionals from across the world are flocking to Australia for its great quality of life and stable economic prospects. An English-speaking country, Australia is not just easy to assimilate into but also has a more cosmopolitan culture thanks to a significant migrant population. Its enviable citizen benefits and progressive policies make it a great destination to settle with your family.
      </Typography>
      <Typography variant="body1" paragraph>
        – Stable economy with jobs across IT, service, healthcare, education, and engineering sectors
      </Typography>
      <Typography variant="body1" paragraph>
        – Citizen-first policies including free healthcare and education
      </Typography>
      <Typography variant="body1" paragraph>
        – A favorable climate with plenty of sunshine
      </Typography>
      <Typography variant="body1" paragraph>
        – Beautiful, multicultural cities that enhance your quality of life
      </Typography>
      <Typography variant="body1" paragraph>
        – Large natural heritage including the Great Barrier Reef and unspoilt forests
      </Typography>

      <Divider sx={{ margin: '20px 0' }} />

      <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
        How To Settle In Australia?
      </Typography>
      <Divider sx={{ marginBottom: 2 }} />
      <Typography variant="body1" paragraph>
        Australia’s pioneering immigration department has streamlined the application process to reduce processing time. However, a comprehensive and accurate application package is vital to taking advantage of this. With a dedicated Australia migration team, we have the knowledge and experience to help you file an application with the highest chances of success. Our team of RMA-certified professionals in our Australian partner office can assess your application and help you file it with confidence.
      </Typography>

      <Divider sx={{ margin: '20px 0' }} />

      <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
        Top Jobs In Australia
      </Typography>
      <Divider sx={{ marginBottom: 2 }} />
      <Typography variant="body1" paragraph>
        Here is a list of the top 5 industries where job prospects are good. The projected job growth in the next three years is also included:
      </Typography>
      <Typography variant="body1" paragraph>
        – Healthcare and Social Assistance - 14.9%
      </Typography>
      <Typography variant="body1" paragraph>
        – Construction - 10%
      </Typography>
      <Typography variant="body1" paragraph>
        – Education and Training - 11.2%
      </Typography>
      <Typography variant="body1" paragraph>
        – Professional, Scientific and Technical Services - 10.2%
      </Typography>
      <Typography variant="body1" paragraph>
        – Accommodation and food services - 9.1%
      </Typography>
    </Box>
    
          {/* FAQ Accordion */}
          <Box sx={{ marginTop: 4 }}>
            {/* <Typography variant="h5" gutterBottom>Frequently Asked Questions</Typography> */}
            <Accordion elevation={2} sx={{ borderRadius: '8px', marginBottom: 2 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5' }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                  Cost Of Studying In Australia
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                <Box sx={{ padding: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                  Usually, courses in Arts, Education, and Humanities are cheaper while subjects like Engineering and Medicine are expensive. Studies at Post Graduate level have higher tuition fees typically and costs are diverse based on the program.
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>

            <Accordion elevation={2} sx={{ borderRadius: '8px', marginBottom: 2 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5' }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                  Work Authorization for Students
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                <Box sx={{ padding: 2 }}>
                  <strong>STUDENT APPLICANT:</strong>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                    <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                    <Typography variant="body1">Students must be over 18 years of age</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                    <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                    <Typography variant="body1">International students in Australia on a valid student visa can work for up to 20 hours per week</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                    <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                    <Typography variant="body1">An exception is, working as an academic assistant. There is no limit to how many days academic assistants may work</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                    <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                    <Typography variant="body1">They are not allowed to be self-employed or work as freelancers</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                    <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                    <Typography variant="body1">After graduation students can apply for the Temporary Graduate visa (subclass 485). The visa will be granted based on the coursework and the category under which the student has applied.</Typography>
                  </Box>
                  <strong>SPOUSE:</strong>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                    <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                    <Typography variant="body1">In general, spouses are given the same rights as the spouse is already in Australia. Therefore, if the spouse in Australia has the right to work, the spouse who comes to join him or her will also have that right. But also note that only work permit holders can apply for the dependant visas.</Typography>
                  </Box>

                </Box>
              </AccordionDetails>
            </Accordion>

            <Accordion elevation={2} sx={{ borderRadius: '8px', marginBottom: 2 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5' }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                  After You Graduate
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                <Box sx={{ padding: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                    <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                    <Typography variant="body1">If you completed a Bachelors, Masters or Doctoral degree, you may be eligible for the Post-Study Work stream of the Temporary Graduate (subclass 485) visa.</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                    <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                    <Typography variant="body1">Graduate Work stream: International students with an eligible qualification who graduated with skills and qualifications that relate to an occupation on the Medium and Long-term Strategic Skills List (MLTSSL). A visa in this stream is granted for 18 months from the date of grant</Typography>
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>

            <Accordion elevation={2} sx={{ borderRadius: '8px', marginBottom: 2 }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#f5f5f5' }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#333' }}>
                Who Is Eligible To Apply To Australia?
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ backgroundColor: '#fff' }}>
                <Box sx={{ padding: 2 }}>

                  <h8>While each program to migrate to Australia has different criteria, there are a few things in common.</h8>
                  
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                    <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                    <Typography variant="body1">Education</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                    <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                    <Typography variant="body1">Experience</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                    <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                    <Typography variant="body1"> PTE Score</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 1 }}>
                    <CheckCircleIcon color="primary" sx={{ marginRight: 1 }} />
                    <Typography variant="body1"> Documents & Proofs</Typography>
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>

          </Box>

          {/* Snackbar for user feedback */}
          <Snackbar
            open={snackbarOpen}
            onClose={handleSnackbarClose}
            message="Get Started button clicked!"
            autoHideDuration={4000}
          />
        </Container>
      </div>
      <Webfoot />
    </div>
  );
};

export default Saustralia;